
import { getIotEvent,getIotEventTypes } from '../../../../api/eastCoastDataApi/device/iotEventApi'

import CONST from '../../../../utils/const';
import Utils from '../../../../utils/utils';

const state = {
    iotEventData: [],
    allIotEventTypes: []
    
};

const getters = {
    getIotEventTypes:(state) => {
        return state.allIotEventTypes
    },

    getIotEventData: (state)  => {

        return state.iotEventData
    },
    
    getScenicIotEventData: (state) => (scenicAreaId = -1) => { 
        const target = state.iotEventData.filter(c => c.scenicAreaId === scenicAreaId)
        return target
    
    }
};

const actions = {
    async getAllIotEventTypes({commit},condition){
        commit('allIotEventTypes',await getIotEventTypes(condition))

    },

    async getIotEvent({commit},condition){
        commit('iotEventData',await getIotEvent(condition))

    }
};

const mutations = {
    allIotEventTypes(state,data){
        if(Utils.isEmptyObject(data)){
            state.allIotEventTypes = [];
        }
        state.allIotEventTypes = data;
    },

    iotEventData(state,data){
        if(Utils.isEmptyObject(data)){
            state.iotEventData = [];
        }
        state.iotEventData = data;

    }

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }